// extracted by mini-css-extract-plugin
module.exports = {"date-picker-days":"WeekDays_date-picker-days__fKtus","full-width":"WeekDays_full-width__q6TBQ","day-label":"WeekDays_day-label__5edbo"};